
























































































































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { PemeriksaanFisikRanap } from "@/types/pemeriksaan_fisik_ranap";

// Komponen presentasional: memutasi properti nested dari prop `value`
// (objek content.fisik milik parent) secara by-reference.
@Component
export default class CardPemeriksaanFisikDewasa extends Vue {
  @Prop({ required: true }) readonly value!: PemeriksaanFisikRanap;
  @Prop({ default: false }) readonly disabled!: boolean;

  indraSections = [
    { key: "penglihatan", label: "Penglihatan" },
    { key: "pendengaran", label: "Pendengaran" },
    { key: "penciuman", label: "Penciuman" }
  ];

  pencernaanGejala = [
    { text: "Tidak ada keluhan", value: "tidak_ada_keluhan" },
    { text: "Mual", value: "mual" },
    { text: "Muntah", value: "muntah" },
    { text: "Hematemesis", value: "hematemesis" },
    { text: "Kembung", value: "kembung" },
    { text: "Ascites", value: "ascites" }
  ];

  pencernaanTambahan = [
    { text: "Distensi", value: "distensi" },
    { text: "Hernia", value: "hernia" },
    { text: "Haemoroid", value: "haemoroid" },
    { text: "Nyeri", value: "nyeri" }
  ];

  babItems = [
    { text: "Normal", value: "normal" },
    { text: "Diare", value: "diare" },
    { text: "Lendir", value: "lendir" },
    { text: "Darah segar", value: "darah_segar" },
    { text: "Konstipasi", value: "konstipasi" },
    { text: "Inkontinensia", value: "inkontinensia" },
    { text: "Melena", value: "melena" }
  ];

  muskuloItems = [
    { text: "Normal", value: "normal" },
    { text: "Nyeri sendi", value: "nyeri_sendi" },
    { text: "Close fraktur", value: "close_fraktur" },
    { text: "Open fraktur", value: "open_fraktur" },
    { text: "Luksasio", value: "luksasio" },
    { text: "Memar", value: "memar" },
    { text: "Luka", value: "luka" },
    { text: "Luka bakar", value: "luka_bakar" },
    { text: "Abses", value: "abses" },
    { text: "Lainnya", value: "lainnya" }
  ];

  muskuloKet = [
    { flag: "nyeri_sendi", key: "nyeri_sendi_ket", label: "Nyeri sendi di" },
    { flag: "close_fraktur", key: "close_fraktur_ket", label: "Close fraktur di" },
    { flag: "open_fraktur", key: "open_fraktur_ket", label: "Open fraktur di" },
    { flag: "luksasio", key: "luksasio_ket", label: "Luksasio" },
    { flag: "memar", key: "memar_ket", label: "Memar di" },
    { flag: "luka", key: "luka_ket", label: "Luka" },
    { flag: "luka_bakar", key: "luka_bakar_ket", label: "Luka bakar di" },
    { flag: "abses", key: "abses_ket", label: "Abses di" },
    { flag: "lainnya", key: "lainnya_ket", label: "Lainnya" }
  ];

  ekstremitasItems = [
    { text: "Normal", value: "normal" },
    { text: "Kesemutan", value: "kesemutan" },
    { text: "Parese", value: "parese" },
    { text: "Plegi", value: "plegi" },
    { text: "Kejang", value: "kejang" },
    { text: "Kaku kuduk", value: "kaku_kuduk" },
    { text: "Trismus", value: "trismus" },
    { text: "Disfangia", value: "disfangia" },
    { text: "Kekuatan otot", value: "kekuatan_otot" }
  ];

  ekstremitasKet = [
    { flag: "kesemutan", key: "kesemutan_ket", label: "Kesemutan di" },
    { flag: "parese", key: "parese_ket", label: "Parese di" },
    { flag: "plegi", key: "plegi_ket", label: "Plegi di" },
    { flag: "kejang", key: "kejang_ket", label: "Kejang di" },
    { flag: "kekuatan_otot", key: "kekuatan_otot_ket", label: "Kekuatan otot" }
  ];

  kulitItems = [
    { text: "Normal", value: "normal" },
    { text: "Kemerahan", value: "kemerahan" },
    { text: "Ptechie", value: "ptechie" },
    { text: "Bula", value: "bula" },
    { text: "Lainnya", value: "lainnya" }
  ];

  perkemihanItems = [
    { text: "Normal", value: "normal" },
    { text: "Nyeri pinggang", value: "nyeri_pinggang" },
    { text: "Retensio urine", value: "retensio_urine" },
    { text: "Inkontinensia", value: "inkontinensia" },
    { text: "Disuria", value: "disuria" },
    { text: "Hematuria", value: "hematuria" },
    { text: "Lainnya", value: "lainnya" }
  ];
}
